import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { HOVER_CARD_DEFAULT_CONTENT_LABEL } from "./hover-card.script";
import "./hover-card.script";
export function RuiHoverCardTrigger({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    class: "rui-hover-card__trigger",
    children: /* @__PURE__ */jsx("span", {
      ...props,
      "data-hover-card-trigger": true,
      class: cx(className),
      children
    })
  });
}
export function RuiHoverCardContent({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "content",
    class: cx("rui-hover-card__content", "rui-floating", className),
    role: "dialog",
    children
  });
}
export function RuiHoverCard({
  children,
  contentLabel = HOVER_CARD_DEFAULT_CONTENT_LABEL,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-hover-card", {
    contentLabel,
    ...props,
    children: /* @__PURE__ */jsx("span", {
      class: "rui-hover-card",
      children
    })
  });
}